import { useCommonDataContext } from "@core/CommonDataContext";
import { MacStage } from "@core/models/MacStage";
import { FCX } from "@datassential/platform-ui-lib/lib/core/models"
import cn from "classnames";
import { useCallback, useMemo } from "react";
import { useSelectFilters } from "@vms/SelectFilters/SelectFiltersContext";

const SelectMacStages: FCX = ({
    className,
    testId,
}) => {
	const { isLoading, macStages } = useCommonDataContext();

	const { selectedFilters, setSelectedFilters } = useSelectFilters();

	const handleSelectMacStage = useCallback((macStageId: number) => () => {
		const filterMacStage = (id: number) => id !== macStageId
		setSelectedFilters((selectedFilters) => ({
			...selectedFilters,
			macStages: (
				selectedFilters.macStages.includes(macStageId)
					? selectedFilters.macStages.filter(filterMacStage)
					: [...selectedFilters.macStages, macStageId]
			),
		}));
	}, [setSelectedFilters]);

	const macStagesItems = useMemo(() => {
		return (macStages ?? [])
			.filter((macStage) => macStage.id !== MacStage.NotSelected)
			.map((macStage, index) => {
				const onClick = handleSelectMacStage(macStage.id ?? 0);
				const isSelected = selectedFilters.macStages.includes(macStage.id ?? 0);
				return (
					<div
						className={
							cn(
								"SelectFiltersButtons__item",
								isSelected && "is-selected",
							)
						}
						key={macStage.id}
						onClick={onClick}
						data-testid={`buttonSelectMacStages_${index}`}
					>
						{macStage.name}
					</div>
				);
			});
	}, [macStages, selectedFilters.macStages, handleSelectMacStage]);

	if (isLoading) {
		return null;
	}

	return (
		<div
			className={
				cn(
					"SelectFiltersButtons",
					className,
				)
			}
			data-testid={testId}
		>
			<div
				className="SelectFiltersButtons__title"
				data-testid="textSelectMacStages"
			>
				MAC STAGES
			</div>
			<div
				className="SelectFiltersButtons__items"
				data-testid="blockSelectMacStages"
			>
				{macStagesItems}
			</div>
		</div>
	);
};

export default SelectMacStages;